/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Model, ModelMixin} from '../common/model.class';
import {WorkDuration} from '../common/values/work-duration.class';

export class ProfessionalReference extends ModelMixin() implements Model<ProfessionalReference> {

    TYPE = ProfessionalReference;

    public name: string;
    public mobilePhone: string;
    public email: string;
    public positionRelationship: string;
    public primaryPracticeSpecialty: string;
    public workFacility: string;
    public workedWithDuration: WorkDuration = {};

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.workedWithDuration) jsonData.workedWithDuration = new WorkDuration(jsonData.workedWithDuration);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/reference/professional-reference.model.ts